// /perfil/guardadas — Salas guardadas (localStorage fav_venues)
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, Heart } from 'lucide-react';
import { COLORS } from './designSystem';
import { EventsService } from './EventsService';
import { getFavVenues } from './userStore';
import { PhoneShell, VenueTile, useSafeBack } from './components';

export default function SavedVenuesPage() {
  const navigate = useNavigate();
  const goBack = useSafeBack('/perfil');
  const [venues, setVenues] = useState(null);
  useEffect(() => {
    (async () => {
      const all = await EventsService.getVenues();
      const favs = getFavVenues().map(String);
      setVenues(all.filter((v) => favs.includes(String(v.id))));
    })();
  }, []);
  return (
    <PhoneShell>
      <header className="px-5 pt-6 pb-4 flex items-center gap-3">
        <button onClick={goBack} className="w-10 h-10 flex items-center justify-center rounded-full" style={{ backgroundColor: COLORS.surface }} data-testid="saved-back"><ChevronLeft size={22} color={COLORS.text} /></button>
        <h1 className="text-white text-xl font-extrabold">Salas guardadas</h1>
      </header>
      <section className="px-5">
        {venues === null ? (
          <p className="text-sm" style={{ color: COLORS.textMuted }}>Cargando…</p>
        ) : venues.length === 0 ? (
          <div className="text-center py-10">
            <div className="w-20 h-20 mx-auto mb-5 flex items-center justify-center rounded-full" style={{ backgroundColor: COLORS.surface, border: `1px solid ${COLORS.border}` }}>
              <Heart size={32} color={COLORS.textMuted} />
            </div>
            <h3 className="text-white font-bold text-lg mb-1">Aún no has guardado ninguna sala</h3>
            <p className="text-sm mb-6" style={{ color: COLORS.textMuted }}>Toca el corazón en una sala para guardarla aquí.</p>
            <button onClick={() => navigate('/venues')} className="px-6 py-3 rounded-full font-bold text-white" style={{ backgroundColor: COLORS.primary }} data-testid="saved-explore-btn">Explorar venues</button>
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-3">
            {venues.map((v) => (<VenueTile key={v.id} venue={v} size="large" onClick={() => navigate(`/venues/${v.id}`)} />))}
          </div>
        )}
      </section>
    </PhoneShell>
  );
}
